document.addEventListener("BSS:changeVariantQV", e => {
  setTimeout(() => {
    const productForm = document.querySelector("[bss-b2b-quickview-product-form]");
    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
  }, 500);
});

document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
      setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
      }, 1000);
    }
  });

  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('appstle_sub_widget')) {
            const cards = document.querySelectorAll(".product-block-group--price");
            cards.forEach(card => {
                let pID = card.querySelector('.m-price[bss-b2b-product-price]')?.getAttribute("bss-b2b-product-id");
                const priceEle = document.querySelector(".appstle_one_time_price_wrapper");
                console.log({card, priceEle})
                if(priceEle) {
                    priceEle.setAttribute("bss-b2b-product-id", pID);           
                    priceEle.setAttribute("bss-b2b-product-price", true);
                }
            })

            BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }
});

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const target = document.getElementById('CartPopup');
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.target.classList?.contains('upcartPopupShow')) {
            handleCpOnCartDrawer();
            console.log("open mini cart");
        }
      }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
  }, 500);
}

const handleCpOnCartDrawer = () => {
  fetch('/cart.js')
  .then(res => res.json())
  .then(data => {
    console.log("data", data);
    const nodes = document.querySelectorAll(".upcart-product-item");

    nodes.forEach((node, index) => {
      const item = data.items[index];
      if (!item) return;
      const moneyNode = node.querySelector(".styles_ProductRow__price__");
      if (moneyNode) {
        console.log("set mini cart", item.key);
        moneyNode.setAttribute("bss-b2b-cart-item-key", item.key);
        moneyNode.setAttribute("bss-b2b-final-line-price", "");
      }
    });

    const subtotalNode = document.querySelector(`[href="/checkout"]`);
    if (subtotalNode) {
      const originalText = subtotalNode.textContent.trim();
      subtotalNode.setAttribute("bss-b2b-cart-total-price", "");
      
      setTimeout(() => {
        const priceText = subtotalNode.textContent.trim();
        if (!priceText.includes("Checkout")) {
          subtotalNode.textContent = `Checkout • ${priceText}`;
        }
      }, 300);
    }

    BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');  
  });

}

// document.addEventListener('DOMContentLoaded', function () {
//   if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
//     const checkBtnInterval = setInterval(() => {
//       const btn = document.querySelector(".rebuy-button.rebuy-cart__checkout-button");
//       if (btn) {
//         const newBtn = btn.cloneNode(true);
//         newBtn.setAttribute("type", "button");
//         btn.parentNode.replaceChild(newBtn, btn);

//         // new event
//         newBtn.addEventListener("click", function(e) {
//           e.preventDefault();
//           console.log("Checkout clicked");
//           BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
//         });
//       }
//     }, 500);
//   }

//   const cartTrigger = document.querySelector('a[data-drawer-id="sidebar-cart"]');
//   if (!cartTrigger) return;

//   // first disable
//   cartTrigger.style.pointerEvents = "none";
//   cartTrigger.style.opacity = "0.5";
//   cartTrigger.style.cursor = "not-allowed";

//   // after 5s enable
//   setTimeout(() => {
//     cartTrigger.style.pointerEvents = "auto";
//     cartTrigger.style.opacity = "1";
//     cartTrigger.style.cursor = ""; 
//     console.log("Cart drawer enabled");
//   }, 4500);

// });